import { ANDROID_URL, IOS_URL } from "../../../components/appBanner";
import { AppleIcon, PlayStoreIcon } from "../../../components/icons";
import { useAuthModal } from "../../../contexts/AuthModalContext";

const STORE_CLASS =
  "inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold bg-gray-900 dark:bg-white text-white dark:text-gray-900 rounded-full hover:bg-gray-700 dark:hover:bg-gray-200 transition-colors";

export const StoreButtons = ({ testId }: { testId: string }) => (
  <div class="flex flex-wrap justify-center gap-3">
    <a href={IOS_URL} target="_blank" rel="noopener noreferrer" class={STORE_CLASS} data-test-click={`${testId}-ios`}>
      <AppleIcon size={18} />
      App Store
    </a>
    <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" class={STORE_CLASS} data-test-click={`${testId}-android`}>
      <PlayStoreIcon size={18} />
      Google Play
    </a>
  </div>
);

const PRIMARY_CLASS =
  "inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg";

export const SignUpButton = ({ label, testId }: { label: string; testId: string }) => {
  const { showAuthModal } = useAuthModal();
  return (
    <button
      type="button"
      class={PRIMARY_CLASS}
      onClick={() => showAuthModal("Sign up for free", "Follow authors, save articles for later and get picks made for you")}
      data-test-click={testId}
    >
      {label}
    </button>
  );
};

export const ExploreLink = ({ href, label, testId }: { href: string; label: string; testId: string }) => (
  <a
    href={href}
    class="inline-flex items-center justify-center px-6 py-3 font-semibold rounded-xl border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-neutral-800 transition-colors"
    data-test-click={testId}
  >
    {label}
  </a>
);
